import $ from 'jquery';

class Dropdown {
  constructor(elm) {
    this.elm = $(elm);
    this.select = this.elm.find('[data-dropdown-select]').first();
    this.placeholder = this.elm.find('[data-dropdown-option]').first();

    this.setupListeners();
    this.changeOption();
  }

  setupListeners() {
    this.select.on('change', this.onChange.bind(this));
  }

  onChange() {
    this.changeOption();
  }

  changeOption() {
    this.placeholder.text(this.select.find('option:selected').text());
  }
}

export default {
  create(selector) {
    const instances = [];
    const elms = document.querySelectorAll(selector);

    for (let i = 0; i < elms.length; i += 1) {
      instances.push(new Dropdown(elms[i]));
    }

    return instances;
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/Dropdown.js